module.exports = __webpack_public_path__ + "files/bb5231d4f596e3cc365beed1fab68e52.png";